import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css"
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Alert,
  Spinner
} from "reactstrap"

import { useFormik, FormikProvider } from "formik";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getFeatures as onGetFeatures,
  addFeature as onAddFeature,
  updateFeature as onUpdateFeature,
  deleteFeature as onDeleteFeature,
} from "store/catalog/actions";
import { isEmpty } from "lodash";

//redux
import { useSelector, useDispatch } from "react-redux";

const Features = props => {
  //meta title
  document.title = "Dane techniczne - Panel administracyjny";

  const dispatch = useDispatch();

  const [feature, setFeature] = useState();

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      feature_id: (feature && feature.feature_id) || '',
      feature_name: (feature && feature.feature_name) || '',
    },
    validationSchema: Yup.object({
      feature_name: Yup.string().required("To pole jest wymagane"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateFeature = {
          feature_id: feature ? feature.feature_id : 0,
          feature_name: values.feature_name,
        };
        dispatch(onUpdateFeature(updateFeature));
        validation.resetForm();
      } else {
        const addFeature = {
          feature_name: values["feature_name"],
        };
        dispatch(onAddFeature(addFeature));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { features } = useSelector(state => ({
    features: state.catalog.dataFeatures.features,
  }));

  const { success } = useSelector(state => ({
    success: state.catalog.dataFeatures.success,
  }));

  const { error } = useSelector(state => ({
    error: state.catalog.dataFeatures.error,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const { SearchBar } = Search

  const columns = [
    {
      dataField: "feature_id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "feature_name",
      text: "Nazwa",
      sort: true,
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Opcje",
      formatter: (cellContent, feature) => (
        <React.Fragment>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleFeatureClick(feature)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edycja
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(feature)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Usuń
              </UncontrolledTooltip>
            </Link>
          </div>
        </React.Fragment>
      ),
    },
  ];

  useEffect(() => {
    if (features && !features.length) {
      dispatch(onGetFeatures());
    }
  }, [dispatch, features]);

  useEffect(() => {
    setFeature(features);
  }, [features]);

  useEffect(() => {
    if (!isEmpty(features) && !!isEdit) {
      setFeature(features);
      setIsEdit(false);
    }
  }, [features]);

  useEffect(() => {
    if (success.open) {
      setTimeout(() => {
        dispatch({
          type: "HIDE_FEATURE_SUCCESS",
        });
      }, 5000)
      
    }
  }, [success]);

  useEffect(() => {
    if (error.open) {
      setTimeout(() => {
        dispatch({
          type: "HIDE_FEATURE_FAIL",
        });
      }, 5000)
      
    }
  }, [error]);

  const toggle = () => {
    setModal(!modal);
  };

  const handleFeatureClick = arg => {
    const feature = arg;

    setFeature({
      feature_id: feature.feature_id,
      feature_name: feature.feature_name,
    });

    setIsEdit(true);

    toggle();
  };

  //delete
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (feature) => {
    setFeature(feature);
    setDeleteModal(true);
  };

  const handleDeleteFeature = () => {
    if (feature.feature_id) {
      dispatch(onDeleteFeature(feature));
      setDeleteModal(false);
    }
  };

  const handleFeatureClicks = () => {
    setFeature("");
    setIsEdit(false);
    toggle();
  };

  const defaultSorted = [
    {
      dataField: "feature_id",
      order: "desc",
    },
  ];

  const NoDataIndication = () => (
    <React.Fragment>
      <Spinner color="secondary"></Spinner>
      <div>Ładowanie danych ...</div>
    </React.Fragment>
  )

  return (
    <FormikProvider value={validation}>
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteFeature}
          onCloseClick={() => setDeleteModal(false)}
        />
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Katalog" breadcrumbItem="Dane techniczne" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {(success || error) && 
                    <Row>
                      <Col lg="auto">
                        <Alert isOpen={success.open}>
                          {success.text}
                        </Alert>
                        <Alert isOpen={error.open} color="danger">
                          {error.text}
                        </Alert>
                      </Col>
                    </Row>}
                    <ToolkitProvider
                      keyField="feature_id"
                      data={features}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {props => (
                        <React.Fragment>
                          <Row>
                            <Col sm="4">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar
                                    {...props.searchProps}
                                    placeholder="Szukaj..."
                                  />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="8">
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleFeatureClicks}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Dodaj dane techniczne
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <BootstrapTable
                                {...props.baseProps}
                                bordered={false}
                                defaultSorted={defaultSorted}
                                pagination={paginationFactory()}
                                classes={"align-middle"}
                                headerWrapperClasses={"table-light"}
                                noDataIndication={() => <NoDataIndication />}
                              />
                              <Modal isOpen={modal} toggle={toggle} size="lg">
                                <ModalHeader toggle={toggle} tag="h4">
                                  {!!isEdit ? "Edytuj dane techniczne" : "Dodaj dane techniczne"}
                                </ModalHeader>
                                <ModalBody>
                                  <Form
                                    onSubmit={e => {
                                      e.preventDefault()
                                      validation.handleSubmit()
                                      return false
                                    }}
                                  >
                                    <Row>
                                      <Col className="col-12">
                                        <div className="mb-3">
                                          <Input
                                            name="feature_id"
                                            type="hidden"
                                            value={validation.values.feature_id || ""}
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <Label className="form-label">Nazwa</Label>
                                          <Input
                                            name="feature_name"
                                            type="text"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.feature_name}
                                            invalid={
                                              validation.touched.feature_name && validation.errors.feature_name ? true : false
                                            }
                                          />
                                          {validation.touched.feature_name && validation.errors.feature_name ? (
                                            <FormFeedback type="invalid">{validation.errors.feature_name}</FormFeedback>
                                          ) : null}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <div className="text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-success save-user"
                                          >
                                            Zapisz
                                          </button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Form>
                                </ModalBody>
                              </Modal>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </FormikProvider>
  )
}

export default withRouter(Features)
